import { IconCheckmarkCircle } from '@tock/icons';
import { Typography, TypographyProps } from 'omakase';
import { checkmark, titleWrapper } from 'components/business/receipts/confirmationHeadingCssDefs';

type ConfirmationHeadingProps = TypographyProps & {
  showCheckmark?: boolean;
};

/**
 * A little utility component to put an checkmark icon at the end of a typography string
 *
 * Used for page heading and dialog headings within the receipt
 */
export const ConfirmationHeading = ({
  children,
  showCheckmark = true,
  ...rest
}: ConfirmationHeadingProps) => {
  return (
    <Typography css={titleWrapper} {...rest}>
      {children}
      {showCheckmark && <IconCheckmarkCircle css={checkmark} />}
    </Typography>
  );
};
